import { ShieldCheck } from "lucide-react";
import { masteryStages } from "../lib/learningEngine";
import type { LearningExercise, LearningPath, LearningState } from "../types";

export function MasterySheet({
  state,
  exercises,
  paths,
}: {
  state: LearningState;
  exercises: LearningExercise[];
  paths: LearningPath[];
}) {
  const stages = masteryStages(state, exercises, paths);
  const abilitySignals = Object.values(state.abilities).some((ability) => ability > 1500);

  return (
    <section className="mastery-sheet" aria-label="Charakterbogen">
      <div className="side-title">
        <ShieldCheck size={18} />
        Charakterbogen
      </div>
      {abilitySignals ? <p className="mastery-hint">Schwerer, weil besser: einzelne Skills steigen bereits im Niveau.</p> : null}
      <div className="mastery-sheet-grid">
        {paths.map((path) => {
          const st = stages[path.id] ?? { neu: 0, lernend: 0, gefestigt: 0, stabil: 0, total: 0 };
          return (
            <article className="path-card mastery-path-card" key={path.id}>
              <strong>{path.label}</strong>
              <span>{st.stabil} von {st.total} pruefungsstabil</span>
              <div className="mastery-body" aria-label={`${path.label} Meisterungs-Verteilung`}>
                <span className="ms-neu">{st.neu} neu</span>
                <span className="ms-lernend">{st.lernend} lernend</span>
                <span className="ms-gefestigt">{st.gefestigt} gefestigt</span>
                <span className="ms-stabil">{st.stabil} stabil</span>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
